export const isNotLastItem = (notificationLength: number, index: number): boolean => {
    return index < notificationLength - 1;
};
